// src/components/ErrorBoundary.js
import React, { Component } from 'react';
import { Alert, Button, Card } from 'react-bootstrap';

/**
 * Komponenta pro zachycení chyb v React aplikaci
 * Zabrání pádu celé aplikace při chybě v komponentě
 */
class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null
        };
    }

    static getDerivedStateFromError(error) {
        // Aktualizace stavu při chybě
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Zde můžeme logovat chybu do služby jako je Sentry nebo Logz.io
        console.error('Error Boundary caught an error:', error, errorInfo);
        this.setState({
            error: error,
            errorInfo: errorInfo
        });

        // Zde bychom mohli odeslat chybu do backend logu nebo externí služby
        // Například: errorService.logError(error, errorInfo);
    }

    handleReset = () => {
        this.setState({
            hasError: false,
            error: null,
            errorInfo: null
        });

        // Pokud máme callback pro reset
        if (this.props.onReset) {
            this.props.onReset();
        }
    }

    render() {
        if (this.state.hasError) {
            // Vlastní UI pro zobrazení chyby
            return (
                <Card className="shadow-sm m-4">
                    <Card.Header className="bg-danger text-white">
                        <h5 className="mb-0">Došlo k chybě</h5>
                    </Card.Header>
                    <Card.Body>
                        <Alert variant="danger">
                            <p>V aplikaci došlo k neočekávané chybě. Zkuste následující:</p>
                            <ul>
                                <li>Obnovte stránku (F5)</li>
                                <li>Vymažte cache prohlížeče</li>
                                <li>Přihlaste se znovu</li>
                            </ul>
                        </Alert>

                        {this.props.showDetails && this.state.error && (
                            <div className="mt-3">
                                <h6>Detaily chyby:</h6>
                                <pre className="bg-light p-3 rounded">
                                    {this.state.error.toString()}
                                    <br />
                                    {this.state.errorInfo && this.state.errorInfo.componentStack}
                                </pre>
                            </div>
                        )}

                        <div className="d-flex justify-content-end mt-3">
                            <Button
                                variant="primary"
                                onClick={this.handleReset}
                            >
                                <i className="fas fa-sync-alt me-2"></i> Zkusit znovu
                            </Button>
                        </div>
                    </Card.Body>
                </Card>
            );
        }

        // Pokud nenastala chyba, vykreslí se potomci normálně
        return this.props.children;
    }
}

export default ErrorBoundary;